import { collection, query, getDocs } from "firebase/firestore";

import { db } from "../../config/firebase";
import { useQuery } from "@tanstack/react-query";

export const useSensorDataTypes = () =>
  useQuery({
    queryKey: ["sensordatatypes"],
    queryFn: async () => {
      try {
        const q = query(collection(db, "sensordatatypes"));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
  });
